export default __webpack_public_path__ + "static/media/shopini.14756738.svg";